/* Cortazu PDP v2 (template product.cz-v2). Cortazu file, not part of Hyper. Loaded by sections/cz-pdp-v2-assets.liquid.
   Progressive: without this script every element still shows, only in its Liquid position.
   1. Stamped rating badge next to the price.   2. "· n colours" after the colour name.
   3. Regreen row into the USP list, logo strip above "Complete the outfit".
   4. Review strip: live score, count, recommend % and three quotes from the Stamped widget (no fixed numbers).
   5. Compare: highlight differences, "+n more" features, mobile column picker.
   6. Size guide links (19 Oct round 2): the Sizebay buttons ("Virtual Fitting Room", "Measurements Table"), which Sizebay
      inserts after the size fieldset (its prescript anchor 'div.product fieldset.product-form__input', position 'after'),
      move into a line under the "Size:" label, above the size buttons (round 3: the label row itself stays as in round 1). Without Sizebay the slot stays hidden. */
(function () {
  'use strict';
  var d = document;

  function onReady(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }

  function buyBox() {
    var main = d.querySelector('.section-main-product');
    if (!main) return;
    // 1. Stamped badge block -> price row
    var price = main.querySelector('.product__block--price');
    var blocks = main.querySelectorAll('.product__blocks > .product__block');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (price && /--@app/.test(b.className) && /stamped/i.test(b.innerHTML) && /badge/i.test(b.innerHTML)) {
        b.classList.add('cz-v2-rating');
        var inst = price.querySelector('form.installment, .installment');
        if (inst) price.insertBefore(b, inst); else price.appendChild(b);
        b.addEventListener('click', function (e) {
          var t = d.getElementById('reviews');
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
        break;
      }
    }
    // 2. colour count
    // 20 Oct round 10 (Wouter): no "· n colours" on the PDP, every swatch is visible there (cards keep their count)
    var sw = null;
    if (sw && !sw.querySelector('.cz-v2-colcount')) {
      var n = sw.querySelectorAll('.cz-sw__item').length;
      var label = sw.querySelector('.cz-sw__label');
      if (label && n > 1) {
        var s = d.createElement('span');
        s.className = 'cz-v2-colcount';
        var word = (window.CZV2 && window.CZV2.colours) || '%N% colours';
        s.textContent = ' · ' + word.replace('%N%', n);
        label.appendChild(s);
      }
    }
    // 3. regreen row + logo strip
    var extra = main.querySelector('[data-cz-v2-usp]');
    var usps = main.querySelector('.cz-pdp-promise .cz-pdp-usps');
    if (extra && usps) {
      var li = extra.querySelector('li');
      if (li) { usps.appendChild(li); extra.remove(); }
    }
    var trust = main.querySelector('[data-cz-v2-trust]');
    var outfit = main.querySelector('cz-pdp-outfit, .cz-outfit');
    if (trust && outfit && outfit.parentNode) outfit.parentNode.insertBefore(trust, outfit);
  }

  // 4. Review strip
  // 22 Oct: score + count = review total of the style (all colours summed, assets/cz-review-total.js), the same number as
  // the rating under the title; quotes still come from this product's Stamped widget.
  function styleTotal() {
    var rt = d.querySelector('.section-main-product [data-cz-rt]');
    if (!rt) return null;
    var c = parseInt(rt.getAttribute('data-final-count') || rt.getAttribute('data-count'), 10) || 0;
    var a = parseFloat(rt.getAttribute('data-final-avg') || rt.getAttribute('data-avg')) || 0;
    return c > 0 && a > 0 ? { count: c, avg: a, key: rt.getAttribute('data-key') } : null;
  }
  function strip() {
    var el = d.querySelector('[data-cz-v2-strip]');
    if (!el) return;
    var done = false;
    var lang0 = (d.documentElement.lang || 'en').slice(0, 2);
    function showTotal() {
      var tot = styleTotal();
      if (!tot) return false;
      var ds = el.dataset;
      var fmt = function (x, dec) { return lang0 === 'en' ? x.toFixed(dec) : x.toFixed(dec).replace('.', ','); };
      var num = function (x) { return x.toLocaleString(lang0 === 'en' ? 'en-GB' : (lang0 === 'de' ? 'de-DE' : 'nl-NL')); };
      el.querySelectorAll('[data-cz-v2-score]').forEach(function (x) { x.textContent = fmt(tot.avg, 1); });
      el.querySelector('[data-cz-v2-outof]').textContent = tot.count === 1 ? ds.sOutofOne : ds.sOutof.replace('%N%', num(tot.count));
      compactN(tot.count, num);
      el.querySelectorAll('[data-cz-v2-show]').forEach(function (x) { x.hidden = false; });
      var f0 = el.querySelector('[data-cz-v2-first]');
      if (f0) f0.hidden = true;
      return true;
    }
    // 31 Oct 2026 (owner): compact mobile line (sections/cz-pdp-v2-strip.liquid), same count as "out of 5 · N reviews"
    function compactN(n, num) {
      var c = el.querySelector('[data-cz-v2-n]');
      if (c && el.dataset.sN) c.textContent = n === 1 ? el.dataset.sNOne : el.dataset.sN.replace('%N%', num(n));
    }
    showTotal();
    d.addEventListener('cz:review-total', showTotal);
    function fill() {
      if (done) return true;
      var w = d.getElementById('stamped-main-widget') || d;
      var sum = w.querySelector('.stamped-summary-text-1[data-count]');
      if (!sum) return false;
      var count = parseInt(sum.getAttribute('data-count'), 10) || 0;
      var rating = parseFloat(sum.getAttribute('data-rating')) || 0;
      if (count > 0 && !w.querySelector('.stamped-review')) return false; // wait for the review list
      done = true;
      var ds = el.dataset;
      if (count === 0 || !rating) { done = false; return false; } // Stamped first paints the cached summary; wait for the live one
      // 29 Oct 2026 (CLS 0.30-0.32 on the Alpine PDP at scroll ~4,800 px: shifted cz-v2-strip__over, the "Read the
      // reviews" button and the sections below): the main widget loads lazily ~800px before the strip, so with a fast
      // scroll the quotes + recommend line arrived while the strip was on screen and grew it. On screen = fill as soon as
      // the strip has left the screen (above it the browser's scroll anchoring keeps the view still, below it nothing
      // visible moves); off screen = fill now, as before.
      var r0 = el.getBoundingClientRect();
      if (r0.bottom > 0 && r0.top < (window.innerHeight || d.documentElement.clientHeight) && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[en.length - 1].isIntersecting) { io.disconnect(); anchored(apply); }
        });
        io.observe(el);
      } else anchored(apply);
      return true;
      // r71 (29 Oct, Playwright: still CLS 0.72 on Alpine 390 at scroll ~6,000 px, sources = this strip): above the screen
      // the browser did not always compensate the growth -> keep the view still ourselves when it did not.
      function anchored(fn) {
        var rb = el.getBoundingClientRect(), y0 = window.pageYOffset;
        fn();
        if (rb.bottom <= 0) {
          var dh = el.getBoundingClientRect().height - rb.height;
          if (Math.abs(dh) > 1 && Math.abs(window.pageYOffset - y0) < 1) window.scrollBy(0, dh);
        }
      }
      function apply() {
        var f0 = el.querySelector('[data-cz-v2-first]');
        if (f0) f0.hidden = true;
        var lang = (d.documentElement.lang || 'en').slice(0, 2);
        var fmt = function (x, dec) { return lang === 'en' ? x.toFixed(dec) : x.toFixed(dec).replace('.', ','); };
        var num = function (x) { return x.toLocaleString(lang === 'en' ? 'en-GB' : (lang === 'de' ? 'de-DE' : 'nl-NL')); };
        el.querySelectorAll('[data-cz-v2-score]').forEach(function (x) { x.textContent = fmt(rating, 1); });
        el.querySelector('[data-cz-v2-outof]').textContent = count === 1 ? ds.sOutofOne : ds.sOutof.replace('%N%', num(count));
        compactN(count, num);
        el.querySelectorAll('[data-cz-v2-show]').forEach(function (x) { x.hidden = false; });
        var recEl = w.querySelector('.stamped-summary-recommend-percent');
        var rec = recEl ? parseInt(recEl.textContent, 10) : NaN;
        if (rec > 0) {
          el.querySelector('[data-cz-v2-rec-text]').textContent = ds.sRec.replace('%P%', rec);
          el.querySelector('[data-cz-v2-rec]').hidden = false;
          var cr = el.querySelector('[data-cz-v2-crec]');
          if (cr && ds.sRecShort) { cr.textContent = ds.sRecShort.replace('%P%', rec); cr.hidden = false; }
        }
        var btn = el.querySelector('[data-cz-v2-readall]');
        var tot = styleTotal();
        if (btn && (!tot || tot.count === count)) btn.firstChild.textContent = (count === 1 ? ds.sReadallOne : ds.sReadall.replace('%N%', num(count))) + ' ';
        showTotal();
        // three short quotes: 4-5 stars, real text, not about returns; 5 stars, verified and longer first
        var revs = [].slice.call(w.querySelectorAll('.stamped-review')).map(function (r) {
          var body = (r.querySelector('.stamped-review-content-body') || {}).textContent || '';
          var loc = r.querySelector('[data-location]');
          return {
            r: parseInt(r.getAttribute('data-rating'), 10) || 0,
            v: r.getAttribute('data-verified') === 'buyer' ? 1 : 0,
            b: body.replace(/\s+/g, ' ').trim(),
            a: ((r.querySelector('.author') || {}).textContent || '').trim(),
            c: loc ? loc.getAttribute('data-location') : ''
          };
        }).filter(function (x) { return x.r >= 4 && x.b.length > 20 && !/return|retour|zurück/i.test(x.b); });
        revs.sort(function (x, y) { return (y.r - x.r) || (y.v - x.v) || (y.b.length - x.b.length); });
        var ul = el.querySelector('[data-cz-v2-quotes]');
        revs.slice(0, 3).forEach(function (x) {
          var t = x.b.length > 140 ? x.b.slice(0, 137).replace(/\s+\S*$/, '') + '…' : x.b;
          var li = d.createElement('li');
          var st = d.createElement('span'); st.className = 'cz-v2-stars'; st.setAttribute('aria-label', x.r + '/5'); st.textContent = '★★★★★'.slice(0, x.r);
          var q = d.createElement('span'); q.className = 'cz-v2-strip__q'; q.textContent = '“' + t + '”';
          var by = d.createElement('span'); by.className = 'cz-v2-strip__by'; by.textContent = x.a + (x.c ? ' · ' + x.c : '');
          li.appendChild(st); li.appendChild(q); li.appendChild(by); ul.appendChild(li);
        });
        if (ul.children.length) ul.hidden = false;
      }
    }
    if (fill()) return;
    var mo = new MutationObserver(function () { if (fill()) mo.disconnect(); });
    mo.observe(d.body, { childList: true, subtree: true });
    // 22 Oct (speed): the main widget loads lazily (layout/theme.liquid); the timers below start when it is requested
    function arm() {
    // No live reviews after 10 s: "Be the first" line (replaced if Stamped still reports reviews later)
    setTimeout(function () {
      if (done) return;
      var w = d.getElementById('stamped-main-widget') || d;
      var sum = w.querySelector('.stamped-summary-text-1[data-count]');
      if (sum && (parseInt(sum.getAttribute('data-count'), 10) || 0) === 0 && !styleTotal()) {
        var f = el.querySelector('[data-cz-v2-first]');
        if (f) f.hidden = false;
      }
    }, 10000);
    setTimeout(function () { mo.disconnect(); }, 30000);
    }
    if (window.czStampedLazy && !window.czStampedLazy.loaded) d.addEventListener('cz:stamped-main', arm, { once: true });
    else arm();
  }

  // 5. Compare
  function compare() {
    d.querySelectorAll('[data-cz-v2-cmp]').forEach(function (c) {
      if (c.dataset.czInit) return;
      c.dataset.czInit = '1';
      var rows = c.querySelectorAll('.cz-v2-cmp__row:not(.cz-v2-cmp__row--cols):not(.cz-v2-cmp__row--cta)');
      function visibleCols() {
        var w = c.getAttribute('data-with');
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        return function (cell) { return !mobile || w === '0' || cell.classList.contains('is-cur') || cell.getAttribute('data-col') === w; };
      }
      function markDiff() {
        var vis = visibleCols();
        rows.forEach(function (r) {
          var vals = {};
          [].forEach.call(r.querySelectorAll('[data-col]'), function (cell) {
            if (!vis(cell)) return;
            var t = r.getAttribute('data-kind') === 'feat' ? (cell.querySelector('p') || cell).textContent : cell.textContent;
            vals[t.replace(/\s+/g, ' ').trim().toLowerCase()] = 1;
          });
          r.classList.toggle('is-diff', Object.keys(vals).length > 1);
        });
      }
      var hi = c.querySelector('[data-cz-v2-hi]');
      if (hi) hi.addEventListener('click', function () {
        var on = hi.getAttribute('aria-pressed') !== 'true';
        hi.setAttribute('aria-pressed', on ? 'true' : 'false');
        markDiff();
        c.classList.toggle('is-hi', on);
      });
      c.querySelectorAll('[data-cz-v2-with]').forEach(function (b) {
        b.addEventListener('click', function () {
          c.setAttribute('data-with', b.getAttribute('data-cz-v2-with'));
          c.querySelectorAll('[data-cz-v2-with]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          markDiff();
        });
      });
      // 19 Oct round 2: the sticky buy bar covered the card buttons (bottom row); slide it away while that row is in view
      var ctaRow = c.querySelector('.cz-v2-cmp__row--cta');
      if (ctaRow && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { d.body.classList.toggle('cz-v2-cmp-cta-visible', en.isIntersecting); });
        }, { threshold: 0 }).observe(ctaRow);
      }
      // features: 20 Oct round 8 (Wouter): a "+n more" button in EVERY column, directly under its features. One open/closed
      // state for the whole table (round 7), so the rows stay aligned; a column with 3 items or fewer keeps an empty
      // placeholder so the buttons sit at the same height.
      var feats = [].slice.call(c.querySelectorAll('.cz-v2-cmp__feat'));
      var max = 0;
      feats.forEach(function (f) { max = Math.max(max, f.querySelectorAll('li').length); });
      if (max > 3) {
        var btns = [];
        var setOpen = function (open) {
          c.classList.toggle('is-feat-open', open);
          btns.forEach(function (x) {
            x.setAttribute('aria-expanded', open ? 'true' : 'false');
            x.textContent = open ? c.dataset.sLess : x.dataset.more;
          });
        };
        feats.forEach(function (f) {
          var n = f.querySelectorAll('li').length - 3;
          var b = d.createElement('button');
          b.type = 'button'; b.className = 'cz-v2-cmp__more'; b.setAttribute('aria-expanded', 'false');
          if (n > 0) {
            b.textContent = c.dataset.sMore.replace('%N%', n);
          } else {
            b.textContent = c.dataset.sLess; b.classList.add('is-empty'); b.setAttribute('aria-hidden', 'true'); b.tabIndex = -1;
          }
          b.dataset.more = b.textContent;
          b.addEventListener('click', function () { setOpen(!c.classList.contains('is-feat-open')); });
          f.parentNode.appendChild(b);
          btns.push(b);
        });
      }
    });
  }

  // 6. Size guide links
  function sizeLinks() {
    var block = d.querySelector('.section-main-product .product__block--variant_picker');
    if (!block) return;
    var isLink = function (el) {
      if (!el || el.nodeType !== 1 || el.closest('.cz-v2-sizelinks')) return false;
      var sig = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '');
      return /(^|\s|-|_)(vfr|szb)/i.test(sig) && !/szb-vfr__base/.test(sig) && el.tagName !== 'SCRIPT' && el.tagName !== 'LINK';
    };
    function place() {
      var fs = block.querySelector('fieldset.product-form__input');
      var row = fs && fs.querySelector('legend');
      if (!row) return;
      var slot = row.querySelector('.cz-v2-sizelinks');
      if (!slot) {
        slot = d.createElement('div');
        slot.className = 'cz-v2-sizelinks';
        slot.hidden = true;
        row.appendChild(slot);
      }
      // Sizebay's container(s) right after the fieldset (or anywhere in this block)
      var found = [].slice.call(block.querySelectorAll('[class*="vfr"], [id*="vfr"], [class*="szb"], [id*="szb"]')).filter(function (el) {
        return isLink(el) && !isLink(el.parentElement);
      });
      found.forEach(function (el) { slot.appendChild(el); });
      if (slot.children.length) slot.hidden = false;
    }
    place();
    new MutationObserver(function () { place(); }).observe(block, { childList: true, subtree: true });
  }

  onReady(function () { buyBox(); strip(); compare(); sizeLinks(); });
  // 27 Oct 2026: the compare table can arrive later (lazy section, assets/cz-lazy.js)
  d.addEventListener('cz:lazy-loaded', function () { compare(); });
})();
